/**
 * @generated SignedSource<<5207b2c70cd9c7954d57f674dd0681e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutinesListItem_Routine$data = {
  readonly currentSchedule: {
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemSchedule_schedule">;
  } | null;
  readonly id: string;
  readonly inProgressOrNextWorkspaceOccasion: {
    readonly issueCount: number;
    readonly sequenceNumber: number;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemStatus_RoutineWorkspaceOccasion">;
  } | null;
  readonly isWorkspaceOwner: boolean;
  readonly orgTopic: {
    readonly name: string;
  } | null;
  readonly workspaceOwnerName: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemContent_routine">;
  readonly " $fragmentType": "WorkspaceRoutinesListItem_Routine";
};
export type WorkspaceRoutinesListItem_Routine$key = {
  readonly " $data"?: WorkspaceRoutinesListItem_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItem_Routine">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceRoutinesListItem_Routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "isWorkspaceOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "workspaceOwnerName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceRoutinesListItemContent_routine"
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "RoutineWorkspaceOccasion",
      "kind": "LinkedField",
      "name": "inProgressOrNextWorkspaceOccasion",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceRoutinesListItemStatus_RoutineWorkspaceOccasion"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sequenceNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "issueCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrgTopic",
      "kind": "LinkedField",
      "name": "orgTopic",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentSchedule",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceRoutinesListItemSchedule_schedule"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "5606e955bcd800d91e758f8dab277560";

export default node;
